import React, { useEffect, useRef } from "react";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useLocation } from "react-router-dom";

const ActivityFiltersPanel = ({ filters, setFilters, onGoClick, onClear }) => {
  const [localRange, setLocalRange] = React.useState(
    filters.dates?.date?.length === 2 ? filters.dates.date : ["", ""]
  );
  const [localSearch, setLocalSearch] = React.useState(filters.search || "");
  const [showCalendar, setShowCalendar] = React.useState(false);
  const calendarRef = useRef(null);

  const [range, setRange] = React.useState([
    {
      startDate: localRange[0] ? new Date(localRange[0]) : new Date(),
      endDate: localRange[1] ? new Date(localRange[1]) : new Date(),
      key: "selection",
    },
  ]);

  useEffect(() => {
    if (
      filters.dates?.date?.[0] &&
      filters.dates?.date?.[1] &&
      (filters.dates.date[0] !== localRange[0] ||
        filters.dates.date[1] !== localRange[1])
    ) {
      const start = new Date(filters.dates.date[0]);
      const end = new Date(filters.dates.date[1]);

      setLocalRange([filters.dates.date[0], filters.dates.date[1]]);
      setRange([
        {
          startDate: start,
          endDate: end,
          key: "selection",
        },
      ]);
    }
  }, [filters.dates?.date]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    }

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  const handleDateChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setRange([ranges.selection]);
    setLocalRange([
      format(startDate, "yyyy-MM-dd"),
      format(endDate, "yyyy-MM-dd"),
    ]);
  };

  const handleGo = () => {
    const selectedPlan =
      filters.planname?.default?.label === "All Plans"
        ? ""
        : filters.planname?.default?.label;

    //onGoClick(localSearch.trim(), localRange, selectedPlan);
    onGoClick(
  localSearch.trim(),
  localRange,
  selectedPlan,
  filters.currentPlan.default.label
);
  };

  const handleClearAll = () => {
    setLocalRange(["", ""]);
    setLocalSearch("");
    onClear();
  };
  const handleSearchInputChange = (e) => {
    setLocalSearch(e.target.value);
  };

  return (
    <div className="row g-2 align-items-end">
      <div
        className="col-12 col-sm-4"
        style={{
          position: "relative",
        }}
      >
        <label
          className="form-label"
          style={{ color: "#f5aa33", fontWeight: 600 }}
        >
          Date Range
        </label>
        <div
          className="form-control date-range"
          onClick={() => setShowCalendar(!showCalendar)}
          style={{ cursor: "pointer" }}
        >
          {localRange[0] && localRange[1]
            ? `${localRange[0]} to ${localRange[1]}`
            : "Select Date Range"}
        </div>

        {showCalendar && (
          <div
            ref={calendarRef}
            style={{
              position: "absolute",
              zIndex: 9999,
              top: "100%",
              left: 0,
              backgroundColor: "white",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            }}
            className="activity-input p-3 rounded"
          >
            <DateRange
              editableDateInputs={true}
              onChange={handleDateChange}
              moveRangeOnFirstSelection={false}
              ranges={range}
              maxDate={new Date()}
              locale={enUS}
            />

            <div className="d-flex justify-content-end mt-2">
              <button
                className="btn btn-sm btn-outline-warning"
                onClick={() => {
                  setLocalRange([null, null]);
                  setRange([
                    {
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                    },
                  ]);
                  //setShowCalendar(false); // Optionally close the calendar popup
                }}
              >
                Clear
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="col-12 col-sm-2 d-grid">
        <label
          className="form-label"
          style={{ color: "#f5aa33", fontWeight: 600 }}
        >
          Activity Name 
        </label>
        <button
          className="dropdown-toggle d-flex justify-content-between align-items-center p-1 py-2 rounded-2 gap-4"
          style={{ color: "#f5aa33" }}
          id="planname"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {
            filters.planname.list.find(
              (plan) => plan.label === filters.planname.default.label
            ).label
          }
        </button>
        <div className="dropdown-menu p-2" aria-labelledby="planname">
          {filters.planname.list.map((plan, index) => (
            <div
              className="dropdown-item"
              style={{
                color:
                  plan.label === filters.planname.default.label
                    ? "#f5aa33"
                    : "",
                cursor: "pointer",
              }}
              key={index}
              onClick={() => {
                setFilters((prev) => ({
                  ...prev,
                  planname: {
                    ...prev.planname,
                    default: { label: plan.label },
                    triger: true,
                  },
                }));
              }}
            >
              {plan.label}
            </div>
          ))}
        </div>
      </div>
      <div className="col-12 col-sm-2 d-grid">
          <label className="form-label" style={{ color: "#f5aa33", fontWeight: 600 }}>
            Current Plan
          </label>

          <button
            className="dropdown-toggle d-flex justify-content-between align-items-center p-1 py-2 rounded-2"
            data-bs-toggle="dropdown"
            style={{ color: "#f5aa33" }}
          >
            {filters.currentPlan.default.label}
          </button>

          <div className="dropdown-menu p-2">
            {filters.currentPlan.list.map((plan, idx) => (
              <div
                key={idx}
                className="dropdown-item"
                  style={{
                      color:
                        plan.label === filters.currentPlan.default.label
                          ? "#f5aa33"
                          : "",
                      cursor: "pointer",
                    }}
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    currentPlan: {
                      ...prev.currentPlan,
                      default: { label: plan.label },
                    },
                  }))
                }
              >
                {plan.label}
              </div>
            ))}
          </div>
        </div>

      <div className="col-12 col-sm-4">
        <label
          htmlFor="searchInput"
          className="form-label"
          style={{ color: "#f5aa33", fontWeight: 600 }}
        >
          Search
        </label>
        <input
          type="text"
          id="searchInput"
          className="form-control activity-input"
          value={localSearch}
          onChange={handleSearchInputChange}
          placeholder="Search by store or user..."
        />
      </div>

      <div className="col-12 col-sm-2 d-grid">
        <button
          type="button"
          className="button-filter text-light p-2 rounded-2"
          onClick={handleGo}
          style={{ background: "rgb(245, 170, 51)", fontSize: "1.25rem" }}
          disabled={
            !localSearch.trim() &&
            !localRange[0] &&
            !localRange[1] &&
            (!filters.planname || filters.planname.default.label === "All")
          }
        >
          GO
        </button>
      </div>

      <div className="col-12 col-sm-2 d-grid">
        <button
          type="button"
          className="btn btn-outline-secondary mt-2 mt-sm-0 button-hv-color"
          onClick={handleClearAll}
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default ActivityFiltersPanel;
